import graphqlClient from "../utils/graphql_client_util";
import { SessionStorageUtil } from "../utils/session_storage_util";

const MUTATIONS = {
  DECRYPT_ASYNC_DATA: `
    mutation DecryptAsyncData($input: DecryptAsyncDataInput!) {
      decryptAsyncData(
        input: $input
      ) {
        success
        error {
          code
          errorType
          message
        }
        data {
          encData
        }
      }
    }
  `,
};

const QUERIES = {
  SERIAL_NUMBER_VERIFY_SUBSCRIPTION: `
    query SerialNumberVerifySubscription($serialNumber: String!) {
      serialNumberVerifySubscription(serialNumber: $serialNumber) {
        success
        error {
          code
          errorType
          message
        }
        data {
          isValid
          message
          notificationType
          receiptId
          subscriptionExpiredDate
          subscriptionStartedDate
          userSeq
        }
      }
    }
  `,
};

export const decryptAsyncData = async (encData = "") => {
  try {
    const data = await graphqlClient.mutation(
      MUTATIONS.DECRYPT_ASYNC_DATA,
      {
        input: {
          decData: encData,
        },
      },
      { useAuth: false }
    );

    if (data.decryptAsyncData.success) {
      return {
        success: true,
        data: data.decryptAsyncData.data,
      };
    } else {
      return {
        success: false,
        error: data.decryptAsyncData.error,
      };
    }
  } catch (err) {
    console.error(err);

    return {};
  }
};

export const serialNumberVerifySubscription = async (serialNumber) => {
  try {
    const data = await graphqlClient.query(
      QUERIES.SERIAL_NUMBER_VERIFY_SUBSCRIPTION,
      {
        serialNumber: serialNumber,
      },
      {
        useAuth: false,
      }
    );

    if (data.serialNumberVerifySubscription.success) {
      return {
        success: true,
        data: data.serialNumberVerifySubscription.data,
      };
    } else {
      return {
        success: false,
        error: data.serialNumberVerifySubscription.error,
      };
    }
  } catch (err) {
    console.error(err);

    return {
      success: false,
      error: "잘못된 접근 방식입니다.",
    };
  }
};

export const serialNumberVerify = async () => {
  if (!SessionStorageUtil.getItem("encSerial")) {
    alert("잘못된 접근방식입니다.");
    return false;
  }

  const decrypt = await decryptAsyncData(
    SessionStorageUtil.getItem("encSerial")
  );

  if (decrypt["success"] === false) {
    alert(decrypt["error"]["message"]);
    return false;
  } else {
    const serialNumber = decrypt["data"]["encData"];
    const verify = await serialNumberVerifySubscription(serialNumber);

    if (verify["success"] === false) {
      alert(verify["error"]);
      return false;
    }
  }

  return true;
};
